import { Fragment, useContext } from 'react';
import { TransportationTypeContext } from '../../contexts/TransportationTypeContext';
import ListTransportationType from './ListTransportationType';
import UpdateTransportationType from './UpdateTransportationType';
import { AuthContext } from '../../contexts/AuthContext';
import { ROLES, PERMISSIONS, NO_PERMISSION } from '../../contexts/constants';
import { useTranslation } from 'react-i18next';

const TransportationType = () => {
	const { t } = useTranslation();
	const { setShowAddTransportationTypeModal } = useContext(TransportationTypeContext);

	const {
		authState: { user }
	} = useContext(AuthContext);

	if (!user) {
		return NO_PERMISSION;
	}

	if (
		!(
			user.Permissions.includes(PERMISSIONS.GET_TRANSPORTATION_TYPE) ||
			user.Roles.includes(ROLES.SUPPER_ADMINISTRATOR)
		)
	) {
		return NO_PERMISSION;
	}
	return (
		<Fragment>
			<div className='horizontal-mainwrapper container clearfix'>
				<div className='explain-dashboard mt-5'>
					<div className='explain-header mb-3'>
						<div className='row'>
							<div className='col-md-4'>
								<h3 className='pull-left'>{t('Transportation Type')}</h3>
							</div>
							<div className='col-md-2 ml-auto'>
								{user.Permissions.includes(PERMISSIONS.INSERT_TRANSPORTATION_TYPE) ||
								user.Roles.includes(ROLES.SUPPER_ADMINISTRATOR) ? (
									<button
										className='right-content btn btn-success btn-block'
										onClick={setShowAddTransportationTypeModal.bind(this, true)}
									>
										<i className='fe fe-plus-circle'></i> {t('Add Transportation Type')}
									</button>
								) : null}
							</div>
						</div>
						<hr />
					</div>
					<ListTransportationType />
					<UpdateTransportationType />
					<div className='margin-bottom-150'></div>
				</div>
			</div>
		</Fragment>
	);
};

export default TransportationType;
